export const cmsPages = [
  {
    key: "home",
    label: "Home",
    path: "/",
    sections: [
      { key: "home-hero", label: "Hero", hint: "Main headline and intro copy", type: "text", fields: ["title", "body", "mediaUrl"] },
      { key: "home-analytics", label: "Data Analytics", hint: "\"Data analytics\" section copy", type: "text", fields: ["title", "subtitle", "body"] },
      { key: "home-offers", label: "What We Offer", hint: "Accordion of services", type: "items", fields: ["title"], itemFields: ["title", "body", "link"] },
      { key: "home-assessments", label: "Assessments", hint: "Scouting section + stat highlights", type: "items", fields: ["title", "body"], itemFields: ["value", "title"] },
      { key: "home-memberships", label: "Memberships Intro", hint: "Memberships section intro copy", type: "text", fields: ["title", "subtitle", "body"] },
      { key: "home-programs", label: "Beyond The Lab (Programs)", hint: "Program grid under Memberships", type: "items", fields: ["title", "subtitle"], itemFields: ["icon", "title", "body", "link"] },
      { key: "home-rehabilitation", label: "Rehabilitation & Recovery", hint: "Rehab section copy + cards", type: "items", fields: ["title", "body"], itemFields: ["icon", "title", "body"] },
      { key: "home-lounge", label: "Formula Lounge", hint: "News & articles teaser", type: "items", fields: ["title"], itemFields: ["value", "title", "body"] },
    ],
  },
  {
    key: "about",
    label: "About",
    path: "/about",
    sections: [
      { key: "about-hero", label: "Hero", hint: "Main headline and intro copy", type: "text", fields: ["title", "subtitle", "body", "mediaUrl"] },
      { key: "about-approach", label: "What Sets Us Apart", hint: "Value grid", type: "items", fields: ["title"], itemFields: ["icon", "title", "body"] },
      { key: "coaching-staff", label: "Coaching Staff", hint: "Individual coach profiles — add a photo, name, title, and bio for each coach", type: "items", fields: ["body"], itemFields: ["mediaUrl", "title", "value", "body"] },
      { key: "about-facility", label: "Facility Teaser", hint: "Facility CTA copy", type: "text", fields: ["title", "body"] },
    ],
  },
  {
    key: "facility",
    label: "Facility",
    path: "/facility",
    sections: [
      { key: "facility-hero", label: "Hero", hint: "Main headline and intro copy", type: "text", fields: ["title", "body", "mediaUrl"] },
      { key: "facility-zones", label: "Facility Zones", hint: "Value grid", type: "items", fields: ["title"], itemFields: ["icon", "title", "body"] },
    ],
  },
  {
    key: "contact",
    label: "Contact",
    path: "/contact",
    sections: [
      { key: "contact-info", label: "Contact Details", hint: "Address, phone, email", type: "items", fields: ["title"], itemFields: ["title", "body", "link"] },
      { key: "contact-hours", label: "Business Hours", hint: "Opening hours list", type: "items", fields: [], itemFields: ["title", "body"] },
    ],
  },
  {
    key: "careers",
    label: "Careers",
    path: "/careers",
    sections: [
      { key: "careers-hero", label: "Hero", hint: "Main headline and intro copy", type: "text", fields: ["title", "body", "mediaUrl"] },
      { key: "careers-values", label: "Why Coach With Us", hint: "Value grid", type: "items", fields: ["title"], itemFields: ["icon", "title", "body"] },
      { key: "careers-openings", label: "Open Positions", hint: "Open coaching & staff roles", type: "text", fields: ["title", "body"] },
    ],
  },
  {
    key: "rentals",
    label: "Field Rentals",
    path: "/rentals",
    sections: [
      { key: "rentals-hero", label: "Hero", hint: "Main headline and intro copy", type: "text", fields: ["title", "body", "mediaUrl"] },
      { key: "rentals-included", label: "What's Included", hint: "Value grid", type: "items", fields: ["title"], itemFields: ["icon", "title", "body"] },
    ],
  },
  {
    key: "technology",
    label: "Technology",
    path: "/technology",
    sections: [
      { key: "technology-hero", label: "Hero", hint: "Main headline and intro copy", type: "text", fields: ["title", "body"] },
      { key: "technology-capabilities", label: "Lab Capabilities", hint: "Value grid", type: "items", fields: [], itemFields: ["icon", "title", "body"] },
      { key: "technology", label: "More On Our Technology", hint: "Lab tools & equipment", type: "text", fields: ["title", "body"] },
    ],
  },
  {
    key: "faq",
    label: "FAQ",
    path: "/faq",
    sections: [
      { key: "faq-hero", label: "Heading", hint: "Page heading text", type: "text", fields: ["title"] },
    ],
  },
  {
    key: "events",
    label: "Camps & Events",
    path: "/events",
    sections: [
      { key: "events-hero", label: "Hero", hint: "Main headline and intro copy", type: "text", fields: ["title", "body", "mediaUrl"] },
      { key: "events-types", label: "What We Host", hint: "Value grid", type: "items", fields: ["title"], itemFields: ["icon", "title", "body"] },
    ],
  },
  {
    key: "memberships",
    label: "Memberships",
    path: "/memberships",
    sections: [
      { key: "memberships-hero", label: "Heading", hint: "Page heading + intro copy", type: "text", fields: ["title", "body"] },
    ],
  },
  {
    key: "programs",
    label: "Programs",
    path: "/programs",
    sections: [
      { key: "programs-hero", label: "Heading", hint: "Page heading + intro copy", type: "text", fields: ["title", "body"] },
    ],
  },
  {
    key: "terms",
    label: "Terms & Conditions",
    path: "/terms",
    sections: [
      { key: "terms-and-conditions", label: "Page Content", hint: "Full page body", type: "text", fields: ["title", "body"] },
    ],
  },
  {
    key: "privacy",
    label: "Privacy Policy",
    path: "/privacy",
    sections: [
      { key: "privacy-policy", label: "Page Content", hint: "Full page body", type: "text", fields: ["title", "body"] },
    ],
  },
];

export const fieldLabels = { title: "Title", subtitle: "Subtitle", body: "Body" };
export const itemFieldLabels = { icon: "Icon", title: "Title", body: "Description", value: "Value / Label", link: "Link", mediaUrl: "Photo" };
